import {Inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BotatoLocalConfig} from '../botato-local.config';
import {DialogConfig} from 'botato-botengine-browser/botato/botato-botengine/source/Core/DialogConfig/DialogConfig.js';

@Injectable()
export class DialogConfigProviderService {

    private dialogConfig: Map<string, DialogConfig> = new Map<string, DialogConfig>();

    constructor(private translateService: TranslateService, @Inject('BOTATO_CONFIG') private configs: BotatoLocalConfig) {
    }

    public setDialogConfig(dialogConfig: DialogConfig, language: string): void {
        this.dialogConfig.set(language, dialogConfig);
    }

    public getDialogConfig(): DialogConfig {
        return this.getDialogConfigForLanguage(this.dialogConfig, this.translateService.getCurrentLang());
    }

    // TODO Why is this public? Maybe check in Uni Bern project
    public getDialogConfigForLanguage(dialogConfigs: Map<string, DialogConfig>, language: string): DialogConfig {
        if (!dialogConfigs.has(language)) {
            throw new Error(`Could not find a DialogConfig for language: ${language}`);
        }

        return dialogConfigs.get(language)!;
    }
}

